import React from "react";
import { MainContainer } from "../components";
import AboutImg from "../assets/images/about.png";
import QuickResponse from "../assets/AboutUs/QuickResponse.svg";
import Experienced from "../assets/AboutUs/Experienced.svg";
import NoGeekSpeak from "../assets/AboutUs/NoGeekSpeak.svg";
import BusinessSavvy from "../assets/AboutUs/BusinessSavvy.svg";
import OneStopShop from "../assets/AboutUs/OneStopShop.svg";
import Satisfaction from "../assets/AboutUs/Satisfaction.svg";
import Placeholder from "../assets/Teams/Placeholder.png";
import Rajkishore from "../assets/Teams/Rajkishore.JPG";
import Shubhankar from "../assets/Teams/Shubhankar.JPG";
import Manglesh from "../assets/Teams/Manglesh.JPG";
import { motion } from "framer-motion";

const fadeInUp = {
  hidden: { opacity: 0, y: 30 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.15, duration: 0.6, ease: "easeOut" },
  }),
};

export default function About() {
  const aboutList = [
    {
      id: 1,
      title: "OUR MISSION",
      description:
        "Building on our technologies and competencies to create value for our customers by addressing their emerging needs and accelerating technological transformation.",
    },
    {
      id: 2,
      title: "OUR VALUES",
      description:
        "Our values guide how we operate daily. They define how we view the world, how we treat our clients, and how we shape the future.",
    },
    {
      id: 3,
      title: "OUR APPROACH & CULTURE",
      description:
        "We believe we are nothing if you are not satisfied. Our passion for helping you achieve your goals is what separates us from competitors.",
    },
  ];

  const Reasons = [
    {
      id: 1,
      title: "Quick Response",
      description:
        "We resolve many issues remotely within minutes—no waiting for in-person visits.",
      icon: QuickResponse,
    },
    {
      id: 2,
      title: "Experienced Team",
      description:
        "12+ years of expertise across diverse technologies, industries, and applications.",
      icon: Experienced,
    },
    {
      id: 3,
      title: "No Geek Speak",
      description:
        "We explain everything in simple terms so you always understand what’s happening.",
      icon: NoGeekSpeak,
    },
    {
      id: 4,
      title: "Business Savvy",
      description:
        "We design technology solutions focused on real business ROI and long-term benefits.",
      icon: BusinessSavvy,
    },
    {
      id: 5,
      title: "One Stop Shop",
      description:
        "We manage your full IT infrastructure—hardware, software, security, and more.",
      icon: OneStopShop,
    },
    {
      id: 6,
      title: "Satisfaction Guaranteed",
      description:
        "If you're not happy, we’re not done. We work until you’re satisfied.",
      icon: Satisfaction,
    },
  ];

  const Teams = [
    {
      id: 1,
      image: Manglesh,
      name: "Manglesh Tiwari",
      description: "Lead Mobile App Developer",
    },
    {
      id: 3,
      image: Shubhankar,
      name: "Shubhankar",
      description: "Lead Backend Developer",
    },
    {
      id: 4,
      image: Rajkishore,
      name: "Rajkishore Jena",
      description: "Lead Frontend Developer",
    },
  ];

  return (
    <MainContainer>
      {/* Hero Section */}
      <section className="relative bg-white bg-opacity-80 flex flex-col md:flex-row">
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          className="flex-1 flex flex-col justify-center px-8 lg:px-28 py-20"
        >
          <h2 className="text-4xl md:text-6xl font-bold text-gray-900 leading-tight">
            About
          </h2>
          <h2 className="text-4xl md:text-6xl font-bold text-primary-color mt-2">
            GitSetCode
          </h2>
          <p className="text-lg text-gray-700 mt-6 max-w-xl">
            At GitSetCode Software Solutions, we're passionate about crafting
            innovative and reliable software solutions tailored to your unique
            business needs.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8 }}
          className="flex-1"
        >
          <img
            src={AboutImg}
            alt="About"
            className="w-full h-full object-cover"
          />
        </motion.div>
      </section>

      {/* About Mission / Values / Culture */}
      <motion.section
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        className="my-20 px-8 lg:px-28 grid gap-6 md:grid-cols-3"
      >
        {aboutList.map((item, idx) => (
          <motion.div
            key={item.id}
            custom={idx}
            variants={fadeInUp}
            className="bg-gray-50 border rounded-xl p-6 shadow-md hover:shadow-xl transition-all duration-300 hover:scale-105"
          >
            <h3 className="text-xl font-semibold text-gray-900 mb-3">
              {item.title}
            </h3>
            <p className="text-gray-700 leading-relaxed">{item.description}</p>
          </motion.div>
        ))}
      </motion.section>

      {/* WHY CHOOSE US */}
      <motion.section
        initial="hidden"
        whileInView="visible"
        variants={fadeInUp}
        className="bg-gray-50 py-16 px-8 lg:px-28 rounded-3xl my-16"
      >
        <h2 className="text-center text-3xl md:text-5xl font-semibold text-gray-900">
          Why Choose Us
        </h2>
        <div className="w-20 h-[3px] bg-primary-color mx-auto mt-4"></div>

        <div className="mt-12 grid gap-10 md:grid-cols-2 lg:grid-cols-3">
          {Reasons.map((item, idx) => (
            <motion.div
              key={item.id}
              custom={idx}
              variants={fadeInUp}
              className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl hover:scale-105 transition-all cursor-default"
            >
              <img src={item.icon} className="h-10 mb-4" alt="icon" />
              <h3 className="text-xl font-bold text-gray-900 mb-2">
                {item.title}
              </h3>
              <p className="text-gray-700">{item.description}</p>
            </motion.div>
          ))}
        </div>

        <p className="text-center mt-10 font-medium text-gray-900">
          Stop wasting time and money —{" "}
          <span className="text-primary-color font-semibold">
            Contact Us Now
          </span>
        </p>
      </motion.section>

      {/* TEAM SECTION */}
      <motion.section
        initial="hidden"
        whileInView="visible"
        variants={fadeInUp}
        className="px-8 lg:px-28 mb-20"
      >
        <h2 className="text-center text-3xl md:text-5xl font-semibold text-gray-900">
          Our Team
        </h2>
        <div className="w-20 h-[3px] bg-primary-color mx-auto mt-4"></div>

        <div className="mt-16 flex flex-wrap justify-center gap-10">
          {Teams.map((item, idx) => (
            <motion.div
              key={item.id}
              custom={idx}
              variants={fadeInUp}
              className="w-64 text-center"
            >
              <img
                src={item.image}
                alt={item.name}
                className="h-32 w-32 rounded-full mx-auto shadow-lg hover:scale-110 transition-transform duration-300"
              />
              <div className="mt-6 bg-gray-100 p-5 rounded-xl shadow-md">
                <p className="font-bold text-lg text-gray-900">{item.name}</p>
                <p className="text-primary-color">{item.description}</p>
                {/* <p className="text-gray-600">{item.mobileNo}</p> */}
              </div>
            </motion.div>
          ))}
        </div>
      </motion.section>
    </MainContainer>
  );
}
